<script setup lang="ts">import { toRef as _toRef, computed as _computed } from 'vue';

import { CountUp } from 'countup.js'
import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'
import { isTest } from '@shared/environment'

const __$temp_1 = (useRecipientLanding()),
  secondaryBgColor = _toRef(__$temp_1, 'secondaryBgColor'),
  gift = _toRef(__$temp_1, 'gift');

const emit = defineEmits(['counterDone'])

const counter = _computed(() => new CountUp('amount-counter', gift.value?.amount || 0, {
  duration: isTest ? 0.1 : 2.0,
  prefix: '$',
  useEasing: false,
}))

function start () {
  return new Promise<void>((resolve) => {
    counter.value?.reset()
    counter.value?.start(() => {
      emit('counterDone')
      resolve()
    })
  })
}

defineExpose({
  start,
  reset: () => counter.value?.reset(),
})
</script>

<template>
  <span
    id="amount-counter"
    class="font-semibold"
    :style="{ color: secondaryBgColor, fontSize: '100px' }"
  />
</template>
